import styled from 'styled-components';

export const OnboardingBlock = styled.div`
  min-height: 100vh;
  background: var(--white);
  color: var(--text-color-50);
`;

export const OnboardingGrid = styled.div`
  display: grid;
  min-height: 100vh;
  width: 100%;
  margin: 0 auto;
  grid-template-columns: 1fr;

  @media (min-width: 1024px) {
    grid-template-columns: ${({ $showRightPanel }) => ($showRightPanel ? '42fr 48fr' : '1fr')};
  }
`;

export const FormColumn = styled.div`
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

export const FormHeader = styled.header`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 28px 32px 0;

  @media (min-width: 1024px) {
    padding: 28px 48px 0;
  }

  img {
    height: 40px;
    width: 160px;
  }
`;

export const HeaderLink = styled.p`
  display: none;
  font-size: 14px;
  color: var(--text-color);

  @media (min-width: 640px) {
    display: block;
  }

  a {
    font-weight: 500;
    color: var(--text-color-50);

    &:hover {
      color: var(--blue);
    }
  }
`;

export const FormMain = styled.main`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;

  @media (min-width: 1024px) {
    padding: 40px 48px;
  }
`;

export const FormContent = styled.div`
  width: 100%;
  max-width: 500px;
`;

export const FormFooter = styled.footer`
  padding: 0 32px 28px;
  font-size: 12px;
  color: var(--text-color);
`;

export const BannerColumn = styled.aside`
  position: relative;
  display: none;
  overflow: hidden;
  background-color: var(--white);
  background-image: var(--onboarding-premium-bg);

  @media (min-width: 1024px) {
    display: block;
  }
`;

export const BannerInner = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
`;

export const ScenesWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 850px;
  margin: 0 auto;
  flex-direction: column;
`;
